import type FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { getHasFeatureFlag } from 'gcs-common/slices/currentUser/currentUserSelectors';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

interface FeatureFlagProtectedRouteProps {
  disabledFlag?: (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
  enabledFlag?: (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
  children: ReactNode;
  redirectTo?: string;
}

const FeatureFlagProtectedRoute = (props: FeatureFlagProtectedRouteProps) => {
  const { disabledFlag = '', enabledFlag = '', children, redirectTo } = props;
  const navigate = useNavigate();
  const hasDisabledFeatureFlag = useSelector(getHasFeatureFlag(disabledFlag));
  const hasEnabledFeatureFlag = useSelector(getHasFeatureFlag(enabledFlag));

  if (enabledFlag && hasEnabledFeatureFlag) {
    return <>{children}</>;
  }

  if (enabledFlag && !hasEnabledFeatureFlag) {
    return null;
  }

  if (disabledFlag && hasDisabledFeatureFlag && redirectTo) {
    navigate(redirectTo);
  }

  if (disabledFlag && hasDisabledFeatureFlag) {
    return null;
  }

  return <>{children}</>;
};

export default FeatureFlagProtectedRoute;
